import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';

import { AuthenticationService } from '../authentication.service';

@Component({
    selector: 'ruckit-forgot-password-dialog',
    templateUrl: './forgot-password-dialog.component.html',
    styleUrls: ['./forgot-password-dialog.component.scss'],
    providers: [AuthenticationService]
})
export class RuckitForgotPasswordDialogComponent {
    model: any = {};
    loading = false;
    success: boolean;
    button = {
      title: 'Send',
      disabled: false,
      type: 'primary'
    };
    errors = [];

    constructor(
      public dialogRef: MatDialogRef<RuckitForgotPasswordDialogComponent>,
      private router: Router,
      private authenticationService: AuthenticationService
    ) { }

    close() {
      this.dialogRef.close()
    }

    submit() {
      this.loading = true;
      this.authenticationService.forgot(this.model.email)
        .subscribe(
          (result) => {
            this.loading = false;
            this.success = true;
            this.button = {
              title: 'Email Sent!',
              disabled: true,
              type: 'primary'
            };

            setTimeout(() => {
              this.dialogRef.close();
            }, 4000);
          },
          (err) => {
            this.errors = err;
            this.success = false;
            this.button = {
              title: 'Email Failed!',
              disabled: true,
              type: 'error'
            };
            setTimeout(() => {
              this.loading = false;
              this.dialogRef.close();
              this.button = {
                title: 'Send',
                disabled: false,
                type: 'primary'
              };
            }, 4000);
          }
        );
    }
}
